import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const MailIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Mail</title>
    <path d="M24,7,4,13V41H44V13Zm0,4.18L40,16v5.47L24,28.8,8,21.45V16Z" />
  </IconBase>
);
